import * as brandColors from '../../../../utils/brand-colors';

export default () => ({
  listItem: {
    paddingLeft: 14,
    paddingRight: 14,
  },
  highlight: {
    background: brandColors.grey[100],
    fontWeight: 500,
    color: brandColors.primary.main,
    '&:hover': { background: brandColors.grey[200] },
    paddingLeft: 10,
    paddingRight: 14,
  },
  highlightContainer: {
    background: brandColors.grey[100],
    color: brandColors.primary.main,
    borderLeft: `4px solid ${brandColors.primary.main}`,
  },
  listItemIcon: { minWidth: 0 },
  listItemIconHighlight: {
    minWidth: 0,
    color: brandColors.primary.main,
  },
  popper: { zIndex: 1 },
});
